import {
  IProposalCancellationReason,
  IProposalWithMetaData,
} from "../common/interfaces/proposals.interface";
import create from "zustand";
import { IWithdrawalMembersInfo } from "../common/interfaces/clubs.interface";
import { CancellationType } from "../common/enums/proposals.enums";

export interface IProposalContext {
  proposals: IProposalWithMetaData[];
  setProposals: (proposal: IProposalWithMetaData[]) => void;
  clearProposals: () => void;
  updateProposal: (proposal: IProposalWithMetaData) => void;
  addNewProposal: (proposal: IProposalWithMetaData) => void;
  updateWithdrawalData: (withdrawal: IWithdrawalMembersInfo) => void;
  cancellationReasons: Map<CancellationType, IProposalCancellationReason[]>;
  setCancellationReasons: (
    cancellationType: CancellationType,
    reasons: IProposalCancellationReason[]
  ) => void;
}

const initialProposalStore = {
  proposals: [],
  cancellationReasons: new Map(),
};

export const proposalsStore = create<IProposalContext>((set, get) => ({
  ...initialProposalStore,
  clearProposals: () => set(() => ({ proposals: [] })),
  setProposals: (proposals: IProposalWithMetaData[]) =>
    set(() => ({ proposals: proposals })),
  updateProposal: (proposal: IProposalWithMetaData) => {
    const addedProposals = [...get().proposals];
    const proposalIndex = addedProposals.findIndex(
      (p) =>
        p.proposalBasicData.proposalAccount.pubkey.toString() ===
        proposal.proposalBasicData.proposalAccount.pubkey.toString()
    );
    addedProposals[proposalIndex] = { ...proposal };
    set({ proposals: addedProposals });
  },
  addNewProposal: (proposal: IProposalWithMetaData) => {
    set({ proposals: [proposal, ...get().proposals] });
  },
  updateWithdrawalData: (withdrawalMembersInfo: IWithdrawalMembersInfo) => {
    const addedProposals = [...get().proposals];
    const foundProposal = addedProposals.findIndex(
      (p) =>
        p.proposalBasicData.proposalAccount.pubkey.toString() ===
        withdrawalMembersInfo.proposal.toString()
    );
    addedProposals[foundProposal] = {
      ...addedProposals[foundProposal],
      metadata: {
        ...addedProposals[foundProposal].metadata,
        withdrawalMembersInfo,
      },
    };
  },
  setCancellationReasons: (
    cancellationType: CancellationType,
    reasons: IProposalCancellationReason[]
  ) => {
    const addedCancellationReasons = get().cancellationReasons;
    addedCancellationReasons.set(cancellationType, reasons);
    set(() => ({ cancellationReasons: addedCancellationReasons }));
  },
}));
